export const estadoColaborador = Object.freeze({
  ACTIVO: "ACTIVO",
  CESADO: "CESADO",
  ONBOARDING: "ONBOARDING",
  SINESTADO: "SINESTADO",
});
